import type { Category, Insight } from '../../types/api';
import { Carousel, StoryCard } from '../ui';

const date = (iso: string) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });
};

/** « Dernières actualités »: carrousel de cartes (image, type, titre, lieu | date), comme les actualités de la référence. */
export default function LatestNews({ insights, categories = [] }: { insights: Insight[]; categories?: Category[] }) {
  const list = insights.filter((n) => n.enable);
  if (list.length === 0) return null;
  const catName = new Map(categories.map((c) => [c.id, c.title]));

  return (
    <section className="bg-white py-16 text-black md:py-24">
      <div className="site-container">
        <Carousel title="Dernières actualités">
          {list.map((n) => (
            <StoryCard
              key={n.id}
              to={`/blog/${n.id}`}
              image={n.image?.url}
              type={(n.category_id && catName.get(n.category_id)) || 'Actualité'}
              title={n.title}
              meta={['Flex Group', date(n.created_at)].filter(Boolean).join(' | ')}
            />
          ))}
        </Carousel>
      </div>
    </section>
  );
}
